import React, { useContext, useEffect, useState, useLayoutEffect } from "react";
import Migas from "../migasGeomedellin/Migas";
import Search from "../buscador/Search";
import OpenModal from "../admin/OpenModal";
import { Container, Form, Button } from "react-bootstrap";
import PiePagina from "../piePagina/PiePagina";
import contextGeomedellin from "../../../context/contextGeomedellin";
import Load from "../../common/Load";
import { UploadFileIcon } from "../../common/UploadFileIcon";
import { MdOutlineModeEdit } from "react-icons/md";
import { BiLineChart } from "react-icons/bi";

import { utils, writeFileXLSX } from "xlsx";

// custom hooks
import { usePermisions } from "../../../hooks/usePermisions";

// variables globales
import { URL_IMAGE_GEOMEDELLIN } from "../../../environment";

import { ModalGeoMedellin } from "../../common/ModalGeomedellin";

import { Combo } from "../combos/Combo";
import { DatePickerGeo } from "../../common/DatePickerGeo";
import { TableReporteOpenData } from "../../common/TableReporteOpenData";
import { Pagination } from "../../common/Pagination";

import getDatos from "../../../services/getDatos";

export default function DatosAbiertos({
  idComponente,
  caractFiltro,
  descripcion,
  fraseCorta,
  imagen,
}) {
  //contexto global geomdellin, donde se almacenan los estados globales de la aplicación
  const { componentes, restablecerEstilos, refDivCardOpenData } =
    useContext(contextGeomedellin);

  const [showModalReporte, setShowModalReporte] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);

  const [rowPerPage, setRowPerPage] = useState(null);

  const [dataReporte, setDataReporte] = useState({
    data: [],
    totalRows: 0,
  });

  const [dataReporteXlsx, setDataReporteXlsx] = useState([]);

  const [combosFiltros, setCombosFiltros] = useState({
    resultFuenteDato: [],
    resultOrigen: [],
    resultTipo: [],
  });

  const [filtrosReportes, setFiltrosReportes] = useState({
    dateRange: [null, null],
    origen: "-1",
    tipo: "-1",
    recurso: "-1",
    page: currentPage,
    rowPerPage: 15,
  });

  const { permissions, infoUser } = usePermisions(idComponente);

  const onHideModalReporte = () => setShowModalReporte(false);

  const listarEstadisticas = async () => {
    try {
      const response = await getDatos(
        "atributos/estadisticas/openData",
        filtrosReportes
      );

      setDataReporte(response);

      setDataReporteXlsx(
        response.data.resultCountYReporteEstadistica.map((estadistica) => {
          return {
            NombreFuenteDato: estadistica.nombre_fuente_dato,
            NombreTematica: estadistica.nombre_tematica,
            FechaRegistro: estadistica.fecha_registro,
            OrigenEstadistica: estadistica.origen_estadistica_txt,
            TipoEstadistica: estadistica.tipo_estadistica,
            NombreCompletoUsuario: estadistica.nombre_completo,
            CorreoUsuario: estadistica.email,
            FormatoDecarga: estadistica.formato,
            Longitud: estadistica.longitud,
            Latitud: estadistica.latitud,
          };
        })
      );
    } catch (error) {
      return false;
    }
  };

  const listarCombosReporte = async () => {
    try {
      const response = await getDatos("atributos/combosestadistica/openData");

      setCombosFiltros(response);
    } catch (err) {
      return false;
    }
  };

  const onChangeFiltros = (target, type) => {
    if (type === "date") {
      setFiltrosReportes((prev) => {
        return { ...prev, dateRange: target };
      });

      return;
    }

    if (type === "combo") {
      const { value, name } = target;

      return setFiltrosReportes((prev) => {
        return { ...prev, [name]: value };
      });
    }
  };

  const exportarXLSX = async () => {
    try {
      const ws = utils.json_to_sheet(dataReporteXlsx);
      const wb = utils.book_new();

      utils.book_append_sheet(wb, ws, "Reporte estadistico");

      const configCols = dataReporteXlsx.map((estadistica) => {
        return { wch: 30 };
      });

      ws["!cols"] = configCols;

      writeFileXLSX(wb, "ReporteEstadistico.xlsx");
    } catch (error) {
      alert("No se puede generar el reporte");
      return false;
    }
  };

  const limpiarFiltros = () => {
    setFiltrosReportes({
      dateRange: [null, null],
      origen: "-1",
      tipo: "-1",
      recurso: "-1",
      page: currentPage,
      rowPerPage: 15,
    });

    setCurrentPage(1);
  };

  useEffect(() => {
    window.scroll(0, 0);
    restablecerEstilos();
    listarCombosReporte();
  }, []);

  useEffect(() => {
    listarEstadisticas();
  }, [filtrosReportes]);

  useEffect(() => {
    setFiltrosReportes((prev) => {
      return { ...prev, page: currentPage, rowPerPage: 15 };
    });
  }, [currentPage]);

  useLayoutEffect(() => {
    const numberCard =
      Math.floor(refDivCardOpenData.current.offsetWidth / 370) * 2;
    setRowPerPage(numberCard);
  }, []);

  return (
    <>
      <Container fluid={true} className="content-datosabiertos">
        <div
          className="img-logo-datosabiertos"
          style={{
            backgroundImage: `url("${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Banner/${idComponente}/${imagen}")`,
          }}
        >
          {permissions.superAdmin ? (
            <div className="edit-banner">
              <UploadFileIcon
                icon={<MdOutlineModeEdit color="#fff" size={"20px"} />}
                idComponente={idComponente}
              />
            </div>
          ) : null}
          <div className="content-degradado">
            <div className="content-contendido-img-banner">
              <label className="lblitulo-txt-imgbanner">Datos abiertos</label>
              <p>
                <label className="lbdescripcion-txt-imgbanner">
                  {descripcion}
                </label>
              </p>
            </div>
          </div>
          <label className="color-borde-img-banner"></label>
        </div>
        <Migas ruta="Datos abiertos" />
        {permissions.admin || permissions.superAdmin ? (
          <div className="container-admin-btn">
            <OpenModal
              componentes={componentes}
              idComponente={idComponente}
              caractFiltro={caractFiltro}
              tituloAdmin={"Nuevo Dato Abierto"}
              infoUser={infoUser}
            />
            <Button
              className="btn-geomedellin btn-register-admin btn-accion btn-lg"
              onClick={() => setShowModalReporte(true)}
            >
              Reporte Estadísticas
            </Button>
          </div>
        ) : (
          ""
        )}
        <Search
          position="vertical"
          pestana={idComponente}
          caractFiltro={caractFiltro}
          element={idComponente}
          fraseCorta={fraseCorta}
          rowPerPage={rowPerPage}
        />
        <ModalGeoMedellin
          scrollOnModal={true}
          size={"lg"}
          dialogClassName="modal-reporte_estadistico"
          title={"Reporte Estadísticas"}
          show={showModalReporte}
          onHideModal={onHideModalReporte}
        >
          <Container fluid>
            <div className="container-filtros_reportes">
              <DatePickerGeo
                stateFather={filtrosReportes.dateRange}
                onChangeDatePicker={onChangeFiltros}
              />
              <Combo
                value={filtrosReportes.origen}
                nameCombo={"origen"}
                onChangeCombo={({ target }) => onChangeFiltros(target, "combo")}
                dataOption={combosFiltros.resultOrigen.map((origen) => {
                  return {
                    id_combo: origen.id_origen,
                    nombreOption: origen.nombre_origen,
                  };
                })}
                titleLabel={"Origen"}
              />
              <Combo
                value={filtrosReportes.tipo}
                nameCombo={"tipo"}
                onChangeCombo={({ target }) => onChangeFiltros(target, "combo")}
                dataOption={combosFiltros.resultTipo.map((tipo) => {
                  return {
                    id_combo: tipo.id_tipo,
                    nombreOption: tipo.nombre_tipo,
                  };
                })}
                titleLabel={"Tipo"}
              />
              <Combo
                value={filtrosReportes.recurso}
                nameCombo={"recurso"}
                onChangeCombo={({ target }) => onChangeFiltros(target, "combo")}
                dataOption={combosFiltros.resultFuenteDato.map((fuenteDato) => {
                  return {
                    id_combo: fuenteDato.id_fuente_dato,
                    nombreOption: fuenteDato.nombre,
                  };
                })}
                titleLabel={"Recurso"}
              />
            </div>
            <div className="flex-containerReportes_buscar">
              <Button
                className="btn-geomedellin btn-register-admin btn-accion me-3"
                onClick={limpiarFiltros}
              >
                Limpiar filtros
              </Button>
              <Button
                className="btn-geomedellin btn-register-admin btn-accion"
                onClick={listarEstadisticas}
              >
                Buscar
              </Button>
            </div>
            <div className="flex-table_geomedellin mt-3">
              <TableReporteOpenData
                data={dataReporte.data.resultDataEstadistica}
              />
              <Pagination
                totalRows={dataReporte.totalRows}
                rowPerPage={15}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                idComponente={idComponente}
                className={"mt-3 px-2"}
              />
              <div className="flex-end_geomedellin mt-3">
                <Button
                  className="btn-geomedellin btn-register-admin btn-accion"
                  onClick={exportarXLSX}
                >
                  Exportar
                </Button>
              </div>
            </div>
          </Container>
        </ModalGeoMedellin>
      </Container>
      <PiePagina fluid={true} />
    </>
  );
}
